import React from 'react';

// Money input with a persistent "£" prefix. Wraps a standard <input> in a
// container that owns the border/background/focus styling, with the £ symbol
// living inside the same border so it reads as part of the field. Solves
// the "is this in £ or $" question without each call site having to add a
// manual prefix.
//
// Container uses focus-within so tabbing into the inner input lights up the
// border the same way a normal input does. The inner input is kept
// transparent so all visible chrome comes from the wrapper.
export default function MoneyInput({
  value,
  onChange,
  disabled = false,
  readOnly = false,
  placeholder,
  step = '0.01',
  min,
  max,
  className = '',
}) {
  return (
    <div className={`w-full flex items-center bg-white border border-line rounded-xl font-['Metropolis'] text-sm focus-within:border-[#92D400] transition-colors ${disabled ? 'opacity-60 cursor-not-allowed' : ''} ${className}`}>
      <span className={`pl-4 pr-2 select-none ${disabled ? 'text-[#51534A]' : 'text-fusion-forest'}`}>£</span>
      <input
        type="number"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        readOnly={readOnly}
        placeholder={placeholder}
        step={step}
        min={min}
        max={max}
        className="flex-1 min-w-0 bg-transparent text-ink py-2.5 pr-4 focus:outline-none disabled:cursor-not-allowed" />
    </div>
  );
}
